import {
  Box,
  Button,
  Chip,
  Divider,
  Grid2,
  Paper,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import MenuItemMui from "@mui/material/MenuItem";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import dayjs from "dayjs";
import { useMemo, useState } from "react";
import { Calculate } from "@mui/icons-material";

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.tz.setDefault("Asia/Colombo");

const GravelDetails = ({
  mainData,
  setMainData,
  isNonMobile,
  concreteMixtureArray,
  chartData,
  calculationOfChart,
  setChartData,
}) => {
  const handleDateOfCast = (newVal) => {
    setMainData((pre) => ({
      ...pre,
      dateOfCast: dayjs(newVal).format("YYYY-MM-DD"),
    }));
    // setDatDiff(calculateDaysBetween);
  };

  const [errorCheck, setErrorCheck] = useState({
    serialNo: {
      error: false,
    },
    dateOfCast: {
      error: false,
    },
    dateOfTest: {
      error: false,
    },
    weight: {
      error: false,
    },
    concreteMixture: {
      error: false,
    },
    areaOfCube: {
      error: false,
    },
    compressiveStrength: {
      error: false,
    },
  });

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Box
        display="grid"
        gap={0.5}
        alignItems="center"
        gridTemplateColumns="repeat(6, minmax(0, 1fr))"
        sx={{
          "& > div": {
            gridColumn: isNonMobile ? undefined : "span 6",
          },
        }}
      >
        <DemoContainer
          components={["DatePicker"]}
          sx={{ paddingTop: "5px", gridColumn: "span 1" }}
        >
          <div style={{ width: "190px" }}>
            <DatePicker
              sx={{
                width: "100%",
                "& .MuiInputBase-root": {
                  height: "40px",
                  overflow: "hidden",
                },
                "& .MuiOutlinedInput-notchedOutline": {
                  border: "none",
                },
              }}
              slotProps={{
                textField: {
                  variant: "outlined",
                  size: "small",
                },
              }}
              label="Date of Test"
              size="small"
              format="YYYY-MM-DD"
              timezone="Asia/Colombo"
              // error={errorCheck.dateOfCast.error}
              value={
                mainData.dateOfCast
                  ? dayjs(mainData.dateOfCast).tz("Asia/Colombo", true)
                  : dayjs().tz("Asia/Colombo", true)
              }
              onChange={(newVal) => {
                const colomboTime = newVal?.tz("Asia/Colombo", true);
                handleDateOfCast(colomboTime);
              }}
            />
          </div>
        </DemoContainer>

        <TextField
          fullWidth
          variant="outlined"
          type="text"
          label="Sample No"
          size="small"
          value={mainData.cement}
          onChange={(e) =>
            setMainData((pre) => ({
              ...pre,
              cement: e.target.value,
            }))
          }
          sx={{ gridColumn: "span 1", marginTop: "5px" }}
        />
        <TextField
          select
          label="ORIGIN"
          fullWidth
          size="small"
          error={errorCheck.concreteMixture.error}
          defaultValue=""
          sx={{ marginTop: "5px", gridColumn: "span 1" }}
          value={mainData.concreteMixture.value}
          onChange={(e) => {
            const selectedValue = e.target.value;
            const selectedOption = concreteMixtureArray.find(
              (item) => item.value === selectedValue,
            );
            setMainData((pre) => ({
              ...pre,
              concreteMixture: selectedOption.label,
              grade: e.target.value,
            }));
          }}
        >
          {concreteMixtureArray.map((data) => (
            <MenuItemMui
              key={data.id}
              data-label={data.label}
              value={data.value}
            >
              {data.label}
            </MenuItemMui>
          ))}
        </TextField>
      </Box>
      <Divider sx={{ margin: "5px 0px 5px 0" }} />

      <Box justifyItems="center">
        <Paper variant="elevation" elevation={2} sx={{ padding: "10px" }}>
          <Box
            display="grid"
            gap={0.5}
            alignItems="center"
            gridTemplateColumns="repeat(7, minmax(0, 1fr))"
            sx={{
              "& > div": {
                gridColumn: isNonMobile ? undefined : "span 7",
              },
            }}
          >
            <Typography
              sx={{ gridColumn: "span 1" }}
              color="info"
              variant="h6"
              textAlign="center"
            >
              SIEVE SIZE (mm)
            </Typography>
            <Typography
              sx={{ gridColumn: "span 1" }}
              color="info"
              textAlign="center"
              variant="h6"
            >
              WEIGHT RETAINED (g)
            </Typography>
            <Typography
              sx={{ gridColumn: "span 1" }}
              color="info"
              textAlign="center"
              variant="h6"
            >
              RETAINED (%)
            </Typography>
            <Typography
              sx={{ gridColumn: "span 1" }}
              color="info"
              textAlign="center"
              variant="h6"
            >
              CUM (%)
            </Typography>
            <Typography
              sx={{ gridColumn: "span 1" }}
              color="info"
              textAlign="center"
              variant="h6"
            >
              PASSING (%)
            </Typography>
            <Typography
              sx={{ gridColumn: "span 1" }}
              color="info"
              textAlign="center"
              variant="h6"
            >
              SPEC VALUE
            </Typography>
            <Typography
              sx={{ gridColumn: "span 1" }}
              color="info"
              textAlign="center"
              variant="h6"
            >
              SATISFACTORY
            </Typography>
            <TextField
              value={chartData.sieve50.toFixed(2)}
              size="small"
              variant="outlined"
              disabled
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
            />
            <TextField
              fullWidth
              variant="outlined"
              type="number"
              size="small"
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
              value={chartData.weight50}
              onChange={(e) =>
                setChartData((pre) => ({
                  ...pre,
                  weight50: e.target.value,
                }))
              }
            />
            <TextField
              value={chartData.retain50.toFixed(3) + "%"}
              size="small"
              variant="outlined"
              disabled
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
            />
            <TextField
              value={chartData.cum50.toFixed(3) + "%"}
              size="small"
              variant="outlined"
              disabled
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
            />
            <TextField
              value={chartData.passing50.toFixed(3) + "%"}
              size="small"
              variant="outlined"
              disabled
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
            />
            <TextField
              value={chartData.spec50}
              size="small"
              variant="outlined"
              disabled
              sx={{
                gridColumn: "span 1",
                "& .MuiInputBase-input": {
                  textAlign: "center",
                  fontSize: "14px",
                  color: "blue",
                },
              }}
              inputProps={{
                style: {
                  textAlign: "center",
                  fontSize: "14px",
                },
              }}
            />
            <Typography
              sx={{ gridColumn: "span 1" }}
              color={chartData.spec50pass ? "success" : "error"}
              textAlign="center"
              variant="h6"
            >
              {chartData.spec50pass ? "SATISFACTORY" : "NOT-SATISFACTORY"}
            </Typography>
            <TextField
              value={chartData.sieve3750.toFixed(2)}
              size="small"
              variant="outlined"
              disabled
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
            />
            <TextField
              fullWidth
              variant="outlined"
              type="number"
              size="small"
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
              value={chartData.weight3750}
              onChange={(e) =>
                setChartData((pre) => ({
                  ...pre,
                  weight3750: e.target.value,
                }))
              }
            />
            <TextField
              value={chartData.retain3750.toFixed(3) + "%"}
              size="small"
              variant="outlined"
              disabled
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
            />
            <TextField
              value={chartData.cum3750.toFixed(3) + "%"}
              size="small"
              variant="outlined"
              disabled
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
            />
            <TextField
              value={chartData.passing3750.toFixed(3) + "%"}
              size="small"
              variant="outlined"
              disabled
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
            />
            <TextField
              value={chartData.spec3750}
              size="small"
              variant="outlined"
              disabled
              sx={{
                gridColumn: "span 1",
                "& .MuiInputBase-input": {
                  textAlign: "center",
                  fontSize: "14px",
                  color: "blue",
                },
              }}
              inputProps={{
                style: {
                  textAlign: "center",
                  fontSize: "14px",
                },
              }}
            />
            <Typography
              sx={{ gridColumn: "span 1" }}
              color={chartData.spec3750pass ? "success" : "error"}
              textAlign="center"
              variant="h6"
            >
              {chartData.spec3750pass ? "SATISFACTORY" : "NOT-SATISFACTORY"}
            </Typography>
            <TextField
              value={chartData.sieve20.toFixed(2)}
              size="small"
              variant="outlined"
              disabled
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
            />
            <TextField
              fullWidth
              variant="outlined"
              type="number"
              size="small"
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
              value={chartData.weight20}
              onChange={(e) =>
                setChartData((pre) => ({
                  ...pre,
                  weight20: e.target.value,
                }))
              }
            />
            <TextField
              value={chartData.retain20.toFixed(3) + "%"}
              size="small"
              variant="outlined"
              disabled
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
            />
            <TextField
              value={chartData.cum20.toFixed(3) + "%"}
              size="small"
              variant="outlined"
              disabled
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
            />
            <TextField
              value={chartData.passing20.toFixed(3) + "%"}
              size="small"
              variant="outlined"
              disabled
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
            />
            <TextField
              value={chartData.spec20}
              size="small"
              variant="outlined"
              disabled
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
            />
            <Typography
              sx={{ gridColumn: "span 1" }}
              color={chartData.spec20pass ? "success" : "error"}
              textAlign="center"
              variant="h6"
            >
              {chartData.spec20pass ? "SATISFACTORY" : "NOT-SATISFACTORY"}
            </Typography>
            <TextField
              value={chartData.sieve05.toFixed(2)}
              size="small"
              variant="outlined"
              disabled
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
            />
            <TextField
              fullWidth
              variant="outlined"
              type="number"
              size="small"
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
              value={chartData.weight05}
              onChange={(e) =>
                setChartData((pre) => ({
                  ...pre,
                  weight05: e.target.value,
                }))
              }
            />
            <TextField
              value={chartData.retain05.toFixed(3) + "%"}
              size="small"
              variant="outlined"
              disabled
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
            />
            <TextField
              value={chartData.cum05.toFixed(3) + "%"}
              size="small"
              variant="outlined"
              disabled
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
            />
            <TextField
              value={chartData.passing05.toFixed(3) + "%"}
              size="small"
              variant="outlined"
              disabled
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
            />
            <TextField
              value={chartData.spec05}
              size="small"
              variant="outlined"
              disabled
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
            />
            <Typography
              sx={{ gridColumn: "span 1" }}
              color={chartData.spec05pass ? "success" : "error"}
              textAlign="center"
              variant="h6"
            >
              {chartData.spec05pass ? "SATISFACTORY" : "NOT-SATISFACTORY"}
            </Typography>
            <TextField
              value={chartData.sieve236.toFixed(2)}
              size="small"
              variant="outlined"
              disabled
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
            />
            <TextField
              fullWidth
              variant="outlined"
              type="number"
              size="small"
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
              value={chartData.weight236}
              onChange={(e) =>
                setChartData((pre) => ({
                  ...pre,
                  weight236: e.target.value,
                }))
              }
            />
            <TextField
              value={chartData.retain236.toFixed(3) + "%"}
              size="small"
              variant="outlined"
              disabled
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
            />
            <TextField
              value={chartData.cum236.toFixed(3) + "%"}
              size="small"
              variant="outlined"
              disabled
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
            />
            <TextField
              value={chartData.passing236.toFixed(3) + "%"}
              size="small"
              variant="outlined"
              disabled
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
            />
            <TextField
              value={chartData.spec236}
              size="small"
              variant="outlined"
              disabled
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
            />
            <Typography
              sx={{ gridColumn: "span 1" }}
              color={chartData.spec236pass ? "success" : "error"}
              textAlign="center"
              variant="h6"
            >
              {chartData.spec236pass ? "SATISFACTORY" : "NOT-SATISFACTORY"}
            </Typography>
            <TextField
              value={chartData.sieve060.toFixed(2)}
              size="small"
              variant="outlined"
              disabled
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
            />
            <TextField
              fullWidth
              variant="outlined"
              type="number"
              size="small"
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
              value={chartData.weight060}
              onChange={(e) =>
                setChartData((pre) => ({
                  ...pre,
                  weight060: e.target.value,
                }))
              }
            />
            <TextField
              value={chartData.retain060.toFixed(3) + "%"}
              size="small"
              variant="outlined"
              disabled
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
            />
            <TextField
              value={chartData.cum060.toFixed(3) + "%"}
              size="small"
              variant="outlined"
              disabled
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
            />
            <TextField
              value={chartData.passing060.toFixed(3) + "%"}
              size="small"
              variant="outlined"
              disabled
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
            />
            <TextField
              value={chartData.spec060}
              size="small"
              variant="outlined"
              disabled
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
            />
            <Typography
              sx={{ gridColumn: "span 1" }}
              color={chartData.spec060pass ? "success" : "error"}
              textAlign="center"
              variant="h6"
            >
              {chartData.spec060pass ? "SATISFACTORY" : "NOT-SATISFACTORY"}
            </Typography>
            <TextField
              value={chartData.sieve075}
              size="small"
              variant="outlined"
              disabled
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
            />
            <TextField
              fullWidth
              variant="outlined"
              type="number"
              size="small"
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
              value={chartData.weight075}
              onChange={(e) =>
                setChartData((pre) => ({
                  ...pre,
                  weight075: e.target.value,
                }))
              }
            />
            <TextField
              value={chartData.retain075.toFixed(3) + "%"}
              size="small"
              variant="outlined"
              disabled
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
            />
            <TextField
              value={chartData.cum075.toFixed(3) + "%"}
              size="small"
              variant="outlined"
              disabled
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
            />
            <TextField
              value={chartData.passing075.toFixed(3) + "%"}
              size="small"
              variant="outlined"
              disabled
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
            />
            <TextField
              value={chartData.spec075}
              size="small"
              variant="outlined"
              disabled
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
            />
            <Typography
              sx={{ gridColumn: "span 1" }}
              color={chartData.spec075pass ? "success" : "error"}
              textAlign="center"
              variant="h6"
            >
              {chartData.spec075pass ? "SATISFACTORY" : "NOT-SATISFACTORY"}
            </Typography>
            <TextField
              value={chartData.sieve0.toFixed(2)}
              size="small"
              variant="outlined"
              disabled
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
            />
            <TextField
              fullWidth
              variant="outlined"
              type="number"
              size="small"
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
              value={chartData.weight0}
              onChange={(e) =>
                setChartData((pre) => ({
                  ...pre,
                  weight0: e.target.value,
                }))
              }
            />
            <TextField
              value={chartData.retain0.toFixed(3) + "%"}
              size="small"
              variant="outlined"
              disabled
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
            />
            <TextField
              value={chartData.cum0.toFixed(3) + "%"}
              size="small"
              variant="outlined"
              disabled
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
            />
            <TextField
              value={chartData.passing0.toFixed(3) + "%"}
              size="small"
              variant="outlined"
              disabled
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
            />
            <TextField
              value="-"
              size="small"
              variant="outlined"
              disabled
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
            />
            <Typography
              sx={{ gridColumn: "span 1" }}
              color="success"
              textAlign="center"
              variant="h6"
            >
              -
            </Typography>
            <Typography
              sx={{ gridColumn: "span 1" }}
              color="info"
              textAlign="center"
              variant="h4"
            >
              TOTAL
            </Typography>
            <Typography
              sx={{ gridColumn: "span 1" }}
              color="info"
              textAlign="center"
              variant="h4"
            >
              {chartData.totalValueOfWeight.toFixed(3)}
            </Typography>
          </Box>
          <Divider sx={{ marginTop: "10px" }} />
          <Button
            variant="contained"
            color="success"
            sx={{ gridColumn: "span 1", marginTop: "5px" }}
            startIcon={<Calculate />}
            onClick={calculationOfChart}
          >
            Calculate
          </Button>
        </Paper>
      </Box>
    </LocalizationProvider>
  );
};

export default GravelDetails;
